import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { MessagePriorityReferenceModel } from "../../models/reference-model/reference-general-model";

@Injectable({
    providedIn: 'root'
})
export class MessagePriorityReferenceService extends ApiServiceBase {
    private readonly REFERENCE_PATH = '/system/MessagePriorityReferences';

    constructor(
        httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getMessageProrityReferences(): Observable<MessagePriorityReferenceModel[]> {
        return this.httpGet<MessagePriorityReferenceModel[]>(this.REFERENCE_PATH, null)
            .pipe(
                map(res => res.body)
            )
    }
}